// Resolução visual apenas: não altera rotas nem permissões.
const normalizePath = value => {
  if (typeof value !== 'string' || !value.trim() || value.trim().startsWith('#')) return '';
  const path = value.split(/[?#]/)[0].replace(/\/+/g, '/').replace(/\/$/, '').toLowerCase();
  return path ? (path.startsWith('/') ? path : '/' + path) : '/';
};
const normalizeTitle = value => typeof value === 'string' ? value.trim().toLowerCase() : '';

export function resolveMenuIcon(menu, pathname, title) {
  const current = normalizePath(pathname);
  const label = normalizeTitle(title);
  let best = null;
  let titleIcon = null;
  const visit = (items, inheritedIcon) => {
    if (!Array.isArray(items)) return;
    items.forEach(item => {
      if (!item || typeof item !== 'object') return;
      const icon = typeof item.icon === 'string' && item.icon ? item.icon : inheritedIcon;
      const path = normalizePath(item.to);
      if (icon && label && normalizeTitle(item.title) === label) titleIcon = icon;
      if (icon && path && (current === path || (path !== '/' && current.startsWith(path + '/')))) {
        if (!best || path.length > best.path.length) best = { path, icon };
      }
      visit(item.subNav, icon);
    });
  };
  visit(menu, null);
  return (best && best.icon) || titleIcon || 'AiOutlineAppstore';
}
